export default __webpack_public_path__ + "static/media/bengaluru.dc790d83.jpg";